import React from 'react';
import { useCharitableGivingContext } from '../../context/useCharitableGivingContext';
import { ReviewItem } from '../Review/components/ReviewItem';

export const DonorReview = () => {
  const {
    workflow: {
      data: { donor },
      options: { donorOptions },
    },
  } = useCharitableGivingContext();

  const getDonor = () => {
    if (donor !== null) {
      const foundDonor = donorOptions.find(({ value }) => value === donor);

      if (foundDonor) {
        return foundDonor.label;
      }
    }

    return '—';
  };

  return <ReviewItem label="Donor" value={getDonor()} />;
};
